var _rect, _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgDynamicExplanation(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.001,
    width: 40,
    height: 40,
    rx: 8,
    fill: "#fff0fe"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14 10c-2.2 0-4 1.8-4 4 0 1.85 1.28 3.41 3 3.86v11.1a1 1 0 102 0v-6.32c.324.458.528.989.93 1.39a9.97 9.97 0 006.2 2.88c.434 1.74 2 3.04 3.87 3.04 2.2 0 4-1.8 4-4s-1.8-4-4-4c-1.83 0-3.38 1.26-3.84 2.95a7.976 7.976 0 01-4.81-2.3c-1.3-1.3-2.1-3-2.3-4.81 1.69-.466 2.95-2.01 2.95-3.84 0-2.2-1.8-4-4-4zm0 2c1.12 0 2 .884 2 2 0 1.12-.884 2-2 2s-2-.884-2-2c0-1.12.884-2 2-2zm12 12c1.12 0 2 .884 2 2 0 1.12-.884 2-2 2-1.09 0-1.94-.836-1.99-1.91a1 1 0 000-.182 1.98 1.98 0 011.99-1.91z"
  })));
}

export default SvgDynamicExplanation;